import {combineReducers} from 'redux'


export default combineReducers({
    toDelete:'res'
})
